import type { RouteConfig } from "@/types/routestypes";

import CustomFieldRoute from "@/routes/moduleRoutes/CustomFieldRoute";
import RoleRoutes from "@/routes/moduleRoutes/RoleRoute";
import UsersRoute from "@/routes/moduleRoutes/UsersRoute";
import AttendanceSettingRoute from "./AttendanceSettingRoute";
import ExpenseRoute from "./ExpenseRoute";
import ProductCatalogueRoute from "./ProductCatalogueRoute";
import AssetManagementRoute from "./AssetManagementRoute";
import CrmRoute from "./CrmRoute";
import UserSeparationRoute from "./UserSeparationRoute";
import DealAndPipelineSettingsRoute from "./DealsNPipelineSettingsRoute";
import TaskSettingRoute from "./TaskSettingRoute";
import OrderSettingsRoute from "./OrderSettingsRoute";
import TerritoryMasterRoute from "@/routes/moduleRoutes/TaskTerritoryRoute";
import OrganizationalUnitsRoute from "@/routes/moduleRoutes/OrganizationalUnitsRoute";
import LeaveSettingRoute from "./LeaveSettingsRoute";
import CompanySettingRoute from "./CompanySettingRoute";
import  GeofenceManagementRoute from "@/routes/moduleRoutes/GeofenceManagementRoute";
import CustomTemplateRoute from "./customTemplate";
import LeadCaptureRoute from "./LeadCaptureRoute";
import { lazy } from "react";

const EmbedTester = lazy(() => import("@/pages/TestingLeadForm/EmbedTester"));

const isTestEnv = import.meta.env.VITE_API_TARGET_URL === "https://test.fieldforceconnect.com/";
const isQAEnv = import.meta.env.VITE_API_TARGET_URL === "https://qa.fieldforceconnect.com/";

const SettingRoute: RouteConfig = {
  path: "",
  pageName: "Settings",
  sidebar: {
    show: true,
    icon: "/assets/media/settingLogo.svg",
  },
  permission: [
    "AllUsersData",
    "CustomFieldManagement",
    "CatalogueView",
    "AttendanceSettings",
    "CompanySettingsEdit",
    "ExpenseSettings",
    "CRMSettings",
    "OrderSettings",
    "LeaveSetting",
    "TerritoryMaster"
  ],
  children: {
    USER_MANAGEMENT: {
      path: "user-management",
      pageName: "User Management",
      sidebar: {
        show: true,
        icon: "",
      },
      children: {
        ALL_USERS: UsersRoute,
        ORGANIZATIONAL_UNITS: OrganizationalUnitsRoute,
        ROLES: RoleRoutes,
        USER_SEPARATION: UserSeparationRoute,
        GEOFENCE_MANAGEMENT: GeofenceManagementRoute,
      }
    },
    LEAD_CAPTURE: LeadCaptureRoute,
    CUSTOM_FIELD: CustomFieldRoute,
    PRODUCT_CATALOGUE: ProductCatalogueRoute,
    ATTENDANCE_SETTING: AttendanceSettingRoute,
    COMPANY_SETTING: CompanySettingRoute,
    EXPENSE: ExpenseRoute,
    CRM_ROUTE: CrmRoute,
    ORDER_SETTINGS: OrderSettingsRoute,
    DEALS_N_PIPELINE_SETTINGS: DealAndPipelineSettingsRoute,
    TERRITORY_MASTER: TerritoryMasterRoute,
    TASK_SETTING: TaskSettingRoute,
    LEAVE_SETTING: LeaveSettingRoute,
    CUSTOM_TEMPLATE: CustomTemplateRoute,
    ASSET_MANAGEMENT: AssetManagementRoute,
    TEST_LEAD: {
      path: "test-lead",
      pageName: "Test",
      element: <EmbedTester />,
      sidebar: { show: (isTestEnv || isQAEnv), icon : "" },
    }
  },
};

export default SettingRoute;
